import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
  currentLanguage: string;
  logicChannel: string;
}

const initialState: LanguageState = {
  currentLanguage: "en",
  logicChannel: "germany",
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<string>) => {
      state.currentLanguage = action.payload;
    },
    setLogicChannel: (state, action: PayloadAction<string>) => {
      state.logicChannel = action.payload;
    },
  },
});

export const { setLanguage, setLogicChannel } = languageSlice.actions;
export default languageSlice.reducer;
